export default "__VITE_ASSET__90764d1b__"